import {areaDepartmentCodes} from '@hconnect/common/consts'
import {mapDepartmentOptions, mapAreaOptions} from '@hconnect/common/mappers'
import {UpmEntityType} from '@hconnect/common/types'
import {getSubNodesByUpmType} from '@hconnect/common/utils'

import {useGetPlantStructure} from '@settings/modules/common/hooks/queries/usePlantStructureQuery'
import {useUrlParam} from '@settings/modules/routing'

export const useKpiNodeIds = () => {
  const nodeId = useUrlParam('nodeId')
  const {data: structure} = useGetPlantStructure({includeEquipment: true})
  const allDepartments = structure
    ? getSubNodesByUpmType(structure, nodeId, UpmEntityType.Department)
    : []
  const availableDepartments = allDepartments.filter((equipment) =>
    areaDepartmentCodes.some((code) => equipment.entityCodesPath?.includes(code))
  )

  const allAreas = structure ? getSubNodesByUpmType(structure, nodeId, UpmEntityType.Area) : []

  return {
    departmentOptions: structure ? mapDepartmentOptions(availableDepartments) : [],
    areaOptions: structure ? mapAreaOptions(allAreas) : []
  }
}
